import { render, staticRenderFns } from "./DateTimePick1.vue?vue&type=template&id=70663802&scoped=true"
import script from "./DateTimePick1.vue?vue&type=script&lang=js"
export * from "./DateTimePick1.vue?vue&type=script&lang=js"
import style0 from "./DateTimePick1.vue?vue&type=style&index=0&id=70663802&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70663802",
  null
  
)

export default component.exports